import styled from 'styled-components';

import { useClickAttachment } from 'hooks/useClickAttachment';
import { SummaryAttachment } from 'models/aiArtifacts/Summary';
import colors from 'styles/theme/colors';

import CitationBadge from './CitationBadge';

export default function SourceChip({
  attachment,
  attachmentType,
}: {
  attachment: SummaryAttachment;
  attachmentType?: string;
}) {
  const handleClick = useClickAttachment(attachment.attachmentId, attachmentType);

  return (
    <StyledBadge onClick={handleClick}>
      <CitationBadge attachment={attachment} clickable={false} hideHoverEffect />
      {attachment.filename}
    </StyledBadge>
  );
}

const StyledBadge = styled.span`
  background-color: ${colors.black3};
  color: ${colors.black100};
  height: 32px;
  padding: 8px 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  border-radius: 43px;
  cursor: pointer;

  * {
    cursor: pointer;
  }

  &:hover {
    border: 1px solid ${colors.purple75};
    padding: 7px 11px;
  }
`;
